(() => {
  if (window.aplovioNavigation) return;
  window.aplovioNavigation = true;
  const layer = document.getElementById('AplovioProductLayer');
  if (document.getElementById('AplovioMobileProductLayer') || document.querySelector('aplovio-header[data-mobile-native]')) return;
  if (!layer || window.Shopify?.designMode || !window.AplovioLayers) return;
  const dialog = layer.querySelector('dialog'), body = layer.querySelector('.ap-layer__body'), status = layer.querySelector('[data-product-status]');
  const title = layer.querySelector('.ap-layer__title');
  const metaSelector = 'title, link[rel="canonical"], meta[name="description"], meta[property^="og:"], meta[name^="twitter:"], script[type="application/ld+json"]';
  const unsupportedApps = doc => !!doc.querySelector('#sg-context, #ssa-context, .shopify-app-block');
  const productURL = value => {
    try {const url = new URL(value, location.href); return url.origin === location.origin && /\/products\/[^/]+\/?$/.test(url.pathname) ? url : null;} catch {return null;}
  };
  let route, content, request, timer, originalMeta, scrollRestoration, syncing = false;
  const session = crypto.randomUUID(), transient = [], reopen = new Map();
  const stamp = (kind, href, layers = []) => ({...(history.state || {}), aplovio:{session, kind, href, layers}});
  async function readDocument(response) {
    const reader = response.body.getReader(), decoder = new TextDecoder();
    let size = 0, html = '';
    while (true) {
      const {done,value} = await reader.read();
      if (done) return html + decoder.decode();
      size += value.byteLength;
      if (size > 2_000_000) {await reader.cancel(); throw new Error('document-size');}
      html += decoder.decode(value, {stream:true});
    }
  }
  function setStatus(error = false) {
    status.hidden = false;
    status.querySelector('[data-product-loading]').hidden = error;
    status.querySelector('[data-product-error]').hidden = !error;
    status.querySelector('a').href = route.url;
    dialog.setAttribute('aria-busy', String(!error));
  }
  function restoreMeta() {
    if (!originalMeta) return;
    document.head.querySelectorAll(metaSelector).forEach(node => node.remove());
    document.head.append(...originalMeta);
    originalMeta = null;
  }
  let layerSyncVersion=0;
  async function syncLayers(desired = []) {
    const version=++layerSyncVersion;
    syncing = true;
    while (transient.length && transient.some((token,index) => token.id !== desired[index]?.id)) {
      const current=window.AplovioLayers.top();if(!current)break;
      await new Promise(resolve=>{current.addEventListener('aplovio:layer-close',resolve,{once:true});window.AplovioLayers.close(current,'history',true);});
      if(version!==layerSyncVersion)return;
    }
    for (const token of desired.slice(transient.length)) {
      const previous = reopen.get(token.id);
      const trigger = previous?.trigger?.isConnected ? previous.trigger : [...body.querySelectorAll('a[data-zoom]')].find(link => link.href === token.href);
      if (trigger) trigger.click();
      else if (previous?.dialog?.isConnected) window.AplovioLayers.open(previous.dialog);
    }
    syncing = false;
  }
  async function load(href) {
    request?.abort(); clearTimeout(timer);
    content?.remove(); content = null;
    route.url = href; setStatus();
    const current = new AbortController(); request = current;
    timer = setTimeout(() => current.abort('timeout'), 15000);
    try {
      const response = await window.AplovioLazy.read(href, {signal:current.signal, credentials:'same-origin', headers:{Accept:'text/html'}});
      if (!response.ok || !productURL(response.url) || !response.headers.get('content-type')?.includes('text/html')) throw new Error('response');
      const html = await readDocument(response);
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const main = doc.querySelector('main[data-ap-main]');
      if (doc.body.dataset.apPage !== 'product' || !main || main.querySelectorAll('[data-ap-product]').length !== 1) throw new Error('template');
      if ([...main.querySelectorAll('*')].some(node => [...node.attributes].some(attribute => /^on/i.test(attribute.name) || ['href','src'].includes(attribute.name) && /^\s*javascript:/i.test(attribute.value)))) throw new Error('unsupported-markup');
      if (unsupportedApps(doc)) {
        if (request === current && !current.signal.aborted) location.replace(href);
        return;
      }
      const manifest = JSON.parse(document.getElementById('AplovioThemeAssets').textContent);
      await window.AplovioLazy.fragment(main, manifest, current.signal);
      if (request !== current || current.signal.aborted || !route) return;
      main.querySelectorAll('script[src], link[rel=stylesheet]').forEach(node => node.remove());
      content = document.createElement('div'); content.dataset.apProductContent = '';
      content.append(...[...main.childNodes].map(node => document.importNode(node, true)));
      body.append(content); body.scrollTop = 0;
      title.textContent = content.querySelector('h1')?.textContent.trim() || title.dataset.default;
      route.url = response.url;
      const state = history.state?.aplovio;
      history.replaceState(stamp(state?.kind === 'transient' ? 'transient' : 'product', route.url, state?.layers || []), '', route.url);
      document.head.querySelectorAll(metaSelector).forEach(node => node.remove());
      document.head.append(...[...doc.head.querySelectorAll(metaSelector)].map(node => document.importNode(node, true)));
      status.hidden = true; dialog.removeAttribute('aria-busy');
      syncLayers(state?.layers || []);
      document.dispatchEvent(new CustomEvent('aplovio:product-route', {detail:{url:route.url, root:content}}));
    } catch {
      if (request === current && route) {setStatus(true); location.assign(href);}
    } finally {if (request === current) clearTimeout(timer);}
  }
  function open(href, trigger, fromHistory = false) {
    if (!route) {
      originalMeta = [...document.head.querySelectorAll(metaSelector)].map(node => node.cloneNode(true));
      route = {url:href, trigger};
      scrollRestoration = history.scrollRestoration; history.scrollRestoration = 'manual';
      if (!fromHistory) history.replaceState(stamp('origin', location.href), '', location.href);
      layer.open(trigger);
    }
    if (!fromHistory) history.pushState(stamp('product', href), '', href);
    title.textContent = title.dataset.default;
    load(href);
  }
  function cleanup() {
    layerSyncVersion++;syncing=false;
    request?.abort(); request = null; clearTimeout(timer);
    content?.remove(); content = null;
    restoreMeta(); transient.length = 0; reopen.clear();
    if (scrollRestoration !== undefined) history.scrollRestoration = scrollRestoration;
    route = null; dialog.removeAttribute('aria-busy');
  }
  dialog.addEventListener('aplovio:layer-beforeclose', event => {
    if (event.target !== dialog || !route || event.detail.reason === 'history') return;
    event.preventDefault(); history.back();
  });
  dialog.addEventListener('aplovio:layer-close', event => {if (event.target === dialog) cleanup();});
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || (link.target && link.target !== '_self') || link.hasAttribute('download') || link.hasAttribute('data-zoom')) return;
    const url = productURL(link.href);
    if (!url) return;
    if (route && content?.contains(link)) {event.preventDefault(); history.replaceState(stamp('product', url.href), '', url.href); load(url.href);}
    else if (!route && link.closest('.collection-products') && matchMedia('(max-width: 989px)').matches && !unsupportedApps(document)) {event.preventDefault(); open(url.href, link);}
  });
  document.addEventListener('aplovio:product-url', event => {
    if (!route || !content?.contains(event.target)) return;
    const url = productURL(event.detail?.url);
    if (url) {route.url = url.href; const state = history.state?.aplovio; history.replaceState(stamp(state?.kind === 'transient' ? 'transient' : 'product', route.url, state?.layers || []), '', route.url);}
  });
  document.addEventListener('aplovio:layer-open', event => {
    if (!route || event.target === dialog) return;
    const token = {id:event.target.id, href:event.detail.trigger?.href || null};
    transient.push(token); reopen.set(token.id, {dialog:event.target, trigger:event.detail.trigger});
    if (!syncing) history.pushState(stamp('transient', route.url, [...transient]), '', route.url);
  });
  document.addEventListener('aplovio:layer-beforeclose', event => {
    if (!route || event.target === dialog || !event.target.hasAttribute('data-layer-history') || syncing || ['history','disconnect'].includes(event.detail.reason)) return;
    if (history.state?.aplovio?.kind === 'transient') {event.preventDefault(); history.back();}
  });
  document.addEventListener('aplovio:layer-close', event => {
    if (!route || event.target === dialog) return;
    const index = transient.findIndex(token => token.id === event.target.id);
    if (index >= 0) transient.splice(index, 1);
    if (!syncing && !['history','disconnect'].includes(event.detail.reason) && history.state?.aplovio?.kind === 'transient') history.back();
  });
  window.addEventListener('popstate', event => {
    const state = event.state?.aplovio;
    if (state?.session !== session) {if (route) {window.AplovioLayers.close(dialog, 'history', true); location.reload();} return;}
    if (state.kind === 'origin') {window.AplovioLayers.close(dialog, 'history', true); return;}
    if (route) {if(dialog.dataset.layerPhase==='closing')window.AplovioLayers.open(dialog,route.trigger);syncLayers(state.layers || []); if (route.url !== state.href) {if (new URL(route.url).pathname === new URL(state.href).pathname) history.replaceState(stamp(state.kind, route.url, state.layers || []), '', route.url); else load(state.href);}}
    else {const trigger = [...document.querySelectorAll('.collection-products a[href]')].find(link => link.href === state.href); open(state.href, trigger, true);}
  });
  window.addEventListener('pagehide', () => {if (route) window.AplovioLayers.close(dialog, 'disconnect', true);});
  window.addEventListener('pageshow', event => {
    const state = history.state?.aplovio;
    if (event.persisted && !route && state?.session === session && state.kind !== 'origin') open(state.href, null, true);
  });
})();
